module.exports = __webpack_public_path__ + "img/icon-yzm.32c9c4ed.png";